import Vue from 'vue'
import Router from 'vue-router'
import f from '@/application/shared/functions.js';
import storeFactory from "@/vuex/store";

var store = storeFactory()

Vue.use(Router);


const redirects = {

	userdata: function(core, to){
		return f.pretry(() => {

			return core.user && core.user.inited

		}).then(() => {
			return core.user.state.is()
		}).then((state) => {

			if(!state){
				return Promise.reject({
					to: '/signin'
				})
			}

			if(!core.user.checkInfo()){
				return Promise.resolve(null)
			}
			else{

				return Promise.reject({
					to: '/userdatawizard'
				})
			}
		})
	},

	features: function(features, core, to){
		return f.pretry(() => {

			return core.user && core.user.inited

		}).then(() => {

			if(core.user.checkFeatures(features)){
				return Promise.resolve(null)
			}
			else{

				return Promise.resolve({
					to: '/profile'
				})

				/*f.pretry(() => {
					return core.vm.$dialog
				}).then(() => {

					core.vm.$dialog.confirm(
						core.vm.$t('labels.accesDeniedLicence'), {
						okText: core.vm.$t('button.ok'),
					}).then((dialog) => {
	
					}).catch( e => {
						
					})

				})
				

				return Promise.reject({
					to: '/features?need=' + features.join(',')
				})*/
			}
		})
	},

	authorized: function (core, to) {

		var rs = ''

		return f.pretry(() => {
			return core.user && core.user.inited
		}).then(() => {
			return core.user.state.is()
		}).then(state => {

			if (state == 1) {
				return Promise.resolve(null)
			}
			else {

				if (to) {

					var redirect = f.hexEncode(to.query.redirect || to.fullPath);

					store.commit('redirect', redirect);

					rs = '?redirect=' + redirect

				}

				return Promise.reject({
					to: '/signin' + rs
				})
			}
		})
	},

	redirect: function (core, to) {
		return redirects.authorized(core, to).then(r => {

			if (store.state.redirect) {

				var redirect = f.hexDecode(store.state.redirect)

				store.commit('redirect', '');

				return Promise.resolve({
					to: redirect
				})
			}

			return Promise.resolve(null)

		})
	},

	notauthorized: function (core, to) {
		return f.pretry(() => {
			return core.user && core.user.inited
		}).then(() => {
			return core.user.state.is()
		}).then(state => {

			if (!state) {
				return Promise.resolve(null)
			}
			else {
				return Promise.resolve({
					to: '/'
				})
			}
		})
	},

	check: function (core, to) {
		return f.pretry(() => {
			return core.user && core.user.inited
		}).then(() => {
			return core.user.state.is()
		}).then(state => {
			return Promise.resolve(null)
		})
	},

	mainpage : function(core, to){

		return redirects.check(core, to).then(() => {
			return core.user.state.is()
		}).then(state => {

			if(state || window.cordova){

				return redirects.redirect(core, to).then((v) => {

					if(v){
						return Promise.resolve(v)
					}

					if (to.name == 'index'){

						var toindex = '/chat'

						if(_.find(core.user.info?.features || [], (v) => {
							return v.name == 'chats'
						})) {
							toindex = '/chats'
						}

						var t = core.user.info?.userinfo?.type

						if(t == 8 || t == 2 || t == 4){
							toindex = '/panel'
						}

						return Promise.reject({
							to : toindex
						})

					}
				})

			}
			else{
				return Promise.reject({
					to : '/main'
				})
			}
		})


		

	}
}

/*const routes = _.map(jsonRoutes, (r) => {
	var route = {
		path : r.path,
		name : r.name
	}

	if(r.customRedirect){
		route.customRedirect = redirects[r.customRedirect]
	}

	if (r.component){
		route.component = () => import('@/' + r.component)
	}

	return route
})*/

const routes = [

	{
		path: '/',
		name: 'index',
		customRedirect: redirects.mainpage
	},

	{
		path: '/stories/:id',
		name: 'story',
		component: () => import('@/views/story'),
		customRedirect: redirects.check
	},

	{
		path: '/applications',
		name: 'applications',
		component: () => import('@/views/landings/applications')
	},

	{
		path: '/courses/:id',
		name: 'course',
		component: () => import('@/views/course'),
		customRedirect: redirects.check
	},

	{
		path: '/joined/:id',
		name: 'joined',
		customRedirect: redirects.authorized,
		component: () => import('@/views/joined') //
	},

	{
		path: '/courses',
		name: 'courses',
		component: () => import('@/views/courses'),
		customRedirect: redirects.userdata,
		dontScrollToTop : true
	},

	{
		path: '/chat',
		name: 'chat',
		component: () => import('@/views/chat'),
		customRedirect: redirects.userdata
	},

	{
		path: '/chats',
		name: 'chats',
		component: () => import('@/views/chats'),
		customRedirect: redirects.authorized,
		features : ['chats']
	},

	{
		path: '/panel',
		name: 'panel',
		component: () => import('@/views/admin/panel'),
		customRedirect: redirects.authorized,
		features : ['admin', 'team', 'moderation', 'promo', 'promounmoderated']
	},

	{
		path: '/panel/users',
		name: 'panel_users',
		component: () => import('@/views/admin/users'),
		customRedirect: redirects.authorized,
		features : ['admin', 'team', 'moderation']
	},

	

	{
		path: '/panel/earnings',
		name: 'panel_earnings',
		component: () => import('@/views/admin/earnings'),
		customRedirect: redirects.authorized,
		features : ['promo', 'team']
	},

	{
		path: '/panel/moderation',
		name: 'panel_moderation',
		component: () => import('@/views/admin/moderation'),
		customRedirect: redirects.authorized,
		features : ['admin', 'moderation']
	},

	

	{
		path: '/panel/partnerinfo',
		name: 'panel_partnerinfo',
		component: () => import('@/views/admin/partnerinfo'),
		customRedirect: redirects.authorized,
		features : ['promounmoderated']
	},

	{
		path: '/panel/payments',
		name: 'panel_payments',
		component: () => import('@/views/admin/payments'),
		customRedirect: redirects.authorized,
		features : ['admin']
	},

	{
		path: '/panel/promocodes',
		name: 'panel_promocodes',
		component: () => import('@/views/admin/promocodes'),
		customRedirect: redirects.authorized,
		features : ['admin', 'team', 'moderation', 'promo']
	},

	{
		path: '/userdatawizard',
		name: 'userdatawizard',
		component: () => import('@/views/userdatawizard'),
		customRedirect: redirects.authorized
	},

	{
		path: '/authorization',
		name: 'authorization',
		component: () => import('@/views/authorization'),
		customRedirect: redirects.notauthorized
	},

	{
		path: '/signin',
		name: 'signin',
		component: () => import('@/views/signin'),
		customRedirect: redirects.notauthorized
	},

	{
		path: '/profile',
		name: 'profile',
		component: () => import('@/views/profile'),
		customRedirect: redirects.authorized // userdata
	},

	{
		path: '/terms',
		name: 'terms',
		component: () => import('@/views/terms')
	},
	{
		path: '/privacy',
		name: 'privacy',
		component: () => import('@/views/privacy')
	},

	{
		path: '/csae',
		name: 'csae',
		component: () => import('@/views/csae')
	},

	{
		path: '/support',
		name: 'support',
		component: () => import('@/views/support'),
		customRedirect: redirects.check
	},

	{
		path: '/faq',
		name: 'faq',
		component: () => import('@/views/faq')
	},

	{
		path: '/changepassword',
		name: 'changepassword',
		component: () => import('@/views/changepassword')
	},

	{
		path: '/setnewpassword',
		name: 'setnewpassword',
		component: () => import('@/views/setnewpassword')
	},

	{
		path: '/changepassword',
		name: 'changepassword',
		component: () => import('@/views/changepassword')
	},

	{
		path: '/forgotpassword',
		name: 'forgotpassword',
		component: () => import('@/views/forgotpassword')
	},

	{
		path: '/confirm',
		name: 'confirm',
		component: () => import('@/views/confirm'),
		customRedirect: redirects.check
	},

	{
		path: '/confirmation',
		name: 'confirmation',
		component: () => import('@/views/confirmation'),
		customRedirect: redirects.check
	},

	
	

	{
		path: '/registration',
		name: 'registration',
		component: () => import('@/views/registration'),
		customRedirect: redirects.notauthorized
	},

	{
		path: '/explore',
		name: 'explore',
		component: () => import('@/views/explore'),
		customRedirect: redirects.authorized
	},

	{
		path: '/features',
		name: 'features',
		component: () => import('@/views/features'),
		customRedirect: redirects.authorized
		
	},

	{
		path: '/about',
		name: 'about',
		component: () => import('@/views/landings/about'),
	},

	{
		path: '/main',
		name: 'main',
		component: () => import('@/views/landings/main'),
	},

	{
		path: '/partnership',
		name: 'partnership',
		component: () => import('@/views/landings/partnership'),
	},

]

if(window.embedded){
	routes = [
		{
			path: '/:id',
			name: 'story',
			component: () => import('@/views/story')
		}
	]
}

const scrollBehavior = function (to, from, savedPosition) {

	const position = {}

	if (to.hash) {
		position.selector = to.hash

		if (document.querySelector(to.hash)) {
			return position
		}

		return false
	}

	return new Promise(resolve => {

		if (to.matched.some(m => !m.meta || !m.meta.dontScrollToTop)) {
			position.x = 0
			position.y = 0
		}

		var r = _.find(routes, (r) => r.name == to.name)

		if (r && r.dontScrollToTop && savedPosition){
			return resolve(savedPosition)
		}

		resolve(position)

	}).catch(e => {
	})
}

const router = new Router({
	base: process.env.BASE_URL,
	routes,
	scrollBehavior,
	mode: window.cordova ? "" : 'history',

})


router.beforeEach((to, from, next) => {

	
	var r = _.find(routes, (r) => r.name == to.name)

	var history = router.internalHistory || []

	if (from.fullPath && from.fullPath != '/') {
		history.push(from.fullPath)
		router.internalHistory = history
	}

	if (r && r.customRedirect) {

		return f.pretry(() => {
			return router.app.core
		}).then(() => {

			router.app.core.store.commit('globalpreloader', true)

			return r.customRedirect(router.app.core, to).then((t) => {


				if (r.features){
					return redirects.features(r.features, router.app.core, to)
				}

				return Promise.resolve(t)

			})
		}).catch(obj => {
			return Promise.resolve(obj)
		}).then(obj => {

			router.app.core.store.commit('globalpreloader', false)

			return obj ? next(obj.to) : next()

		}).catch(e => {
			
		})

	}

	next()
})

router.afterEach(() => {
	
})



export default router